import Dexie, { type EntityTable } from 'dexie';
import type { RosterEntry } from '@nostos/shared';

/**
 * Local IndexedDB store (clinician device only). Holds the roster — the PHI
 * re-identification key — and, later, disposable read-through caches of server data.
 * Managed by Dexie's own versioned schema, separate from the server (Drizzle) schema.
 */
export class NostosLocalDb extends Dexie {
  roster!: EntityTable<RosterEntry, 'id'>;

  constructor() {
    super('nostos-local');
    this.version(1).stores({
      // Indexed fields only; full objects are stored regardless.
      roster: 'id, token, assignmentId, athleteName',
    });
  }
}

export const localDb = new NostosLocalDb();
